"use client";

import type { ReactNode } from "react";

import Autoplay from "embla-carousel-autoplay";
import { Link } from "next-view-transitions";
import Image from "next/image";
import { notFound } from "next/navigation";

import NavigationBar from "~/lib/components/navigation-bar";
import { Carousel, CarouselContent, CarouselItem } from "~/lib/shadcn/components/ui/carousel";
import aerial from "~/public/aerial.jpg";
import bedroom from "~/public/bedroom.jpg";
import outside from "~/public/outside.jpg";
import villa from "~/public/villa.jpg";
import yoga from "~/public/yoga.jpg";

import { getMenuData } from "../(marketing)/layout";

export default async function OnboardingLayout({
	children,
}: Readonly<{
	children: ReactNode;
}>) {
	const data = await getMenuData();
	if (!data) {
		return notFound();
	}
	return (
		<>
			<NavigationBar className="!text-black dark:!text-white from-transparent" menuData={data} />
			<div className="grid min-h-svh lg:grid-cols-2">
				<div className="flex flex-col gap-4 p-6 md:p-10 bg-muted dark:bg-muted">
					<div className="flex flex-col flex-1 gap-6 items-center justify-center">
						<div className="w-full max-w-screen-sm bg-[#4D5558] !text-white p-6 md:p-10">{children}</div>
						<div className="text-balance text-center text-xs text-muted-foreground [&_a]:underline [&_a]:underline-offset-4 max-w-xs">
							By continuing, you agree to our{" "}
							<Link className="hover:text-primary" href="/terms-and-conditions" target="_blank">
								Terms & Conditions
							</Link>{" "}
							and{" "}
							<Link className="hover:text-primary" href="/privacy-policy" target="_blank">
								Privacy Policy
							</Link>
							.
						</div>
					</div>
				</div>
				<div className="relative hidden lg:block">
					<Carousel
						className="w-full h-full"
						opts={{
							loop: true,
						}}
						plugins={[
							Autoplay({
								delay: 3000,
							}),
						]}
					>
						<CarouselContent className="h-full w-full -ml-0">
							<CarouselItem className="flex items-center justify-center relative w-full h-full pl-0">
								<Image
									alt="Outside"
									className="w-full h-full object-fit object-cover"
									fill
									placeholder="blur"
									priority
									sizes="50vw"
									src={outside}
								/>
							</CarouselItem>
							<CarouselItem className="flex items-center justify-center relative w-full h-full pl-0">
								<Image
									alt="Aerial"
									className="w-full h-full object-fit object-cover"
									fill
									placeholder="blur"
									priority
									sizes="50vw"
									src={aerial}
								/>
							</CarouselItem>
							<CarouselItem className="flex items-center justify-center relative w-full h-full pl-0">
								<Image
									alt="bedroom"
									className="w-full h-full object-fit object-cover"
									fill
									placeholder="blur"
									priority
									sizes="50vw"
									src={bedroom}
								/>
							</CarouselItem>
							<CarouselItem className="flex items-center justify-center relative w-full h-full pl-0">
								<Image
									alt="villa"
									className="w-full h-full object-fit object-cover"
									fill
									placeholder="blur"
									priority
									sizes="50vw"
									src={villa}
								/>
							</CarouselItem>
							<CarouselItem className="flex items-center justify-center relative w-full h-full pl-0">
								<Image
									alt="yoga"
									className="w-full h-full object-fit object-cover"
									fill
									placeholder="blur"
									priority
									sizes="50vw"
									src={yoga}
								/>
							</CarouselItem>
						</CarouselContent>
					</Carousel>
				</div>
			</div>
		</>
	);
}
